module.exports = __webpack_public_path__ + "img/icn-sub-t3.d59f622e.png";